import axios from 'axios';
import { getApiRoute } from '../../config';
import store from '../store';

const http = axios.create({
  baseURL: process.env.VUE_APP_API_BASEURL,
  timeout: 5000,
});

http.interceptors.request.use((requestConfig) => {
  const config = store.getters.getGameGetter({ specificGame: 'keno', getter: 'config' });
  const { token } = store.state;

  const { tenantId, productId, locale } = config;
  const setHeaders = (headers) => Object.assign(requestConfig.headers, headers);
  setHeaders({
    'X-NSFT-NGS-COMPANY': tenantId,
    'X-NSFT-NGS-PRODUCT': productId,
    'Seven-Locale': locale,
    Authorization: `Bearer ${token}`,
  });
  return requestConfig;
});
export default {
  async getPaytable() {
    const paytable = await http.get(
      `${getApiRoute('ngsURL', { productName: 'keno' })}${getApiRoute('paytable', { productName: 'keno' })}`,
    );
    return paytable.data;
  },
};
